import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-specification",
  "use": "icon-specification-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-specification\"><path d=\"M148.5 471.4h301.9V168.6H148.5v302.8zm46-256.8h209.9v210.8H194.5V214.6z\" /><path d=\"M278.5 327.2L252.2 299l-33.7 31.3 57.6 61.8L379 296.5l-31.3-33.7zm276.9-94.1h320.1v46H555.4zm0 127.8h320.1v46H555.4zM148.5 855.4h301.9V552.6H148.5v302.8zm46-256.8h209.9v210.8H194.5V598.6z\" /><path d=\"M278.5 711.3l-26.3-28.2-33.7 31.3 57.6 61.8L379 680.6l-31.3-33.7zm276.9-94.1h320.1v46H555.4zm0 127.8h320.1v46H555.4z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol